import { useMutation, useQueryClient } from '@tanstack/react-query';

import { analyzeCompany, generatePipeline, generatePipelineWithLeads } from '../../api/crmApi';
import { pipelinesKeys } from '../pipelines/keys';

export function useAnalyzeCompany() {
	return useMutation({
		mutationKey: ['crm', 'pipelineGenerator', 'analyze'],
		mutationFn: analyzeCompany,
	});
}

export function useGeneratePipeline() {
	const qc = useQueryClient();
	return useMutation({
		mutationKey: ['crm', 'pipelineGenerator', 'generate'],
		mutationFn: generatePipeline,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pipelinesKeys.all });
		},
	});
}

export function useGeneratePipelineWithLeads() {
	const qc = useQueryClient();
	return useMutation({
		mutationKey: ['crm', 'pipelineGenerator', 'generateWithLeads'],
		mutationFn: generatePipelineWithLeads,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pipelinesKeys.all });
		},
	});
}
